export const GenreArray = [
  '인공지능',
  '데이터분석',
  '디자인',
  '게임',
  '하드웨어',
  '언어',
  '앱',
  '이론',
  '웹',
  '기타',
];
